// src/app/pages/shared-session-loader/shared-session-loader.component.ts

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {SessionPersistenceService} from '../../modules/projects/session-manager/session-persistence.service';

@Component({
  selector: 'app-shared-session-loader',
  template: '<div style="height: 100vh; display: flex; align-items: center; justify-content: center;"><div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div></div>',
})
export class SharedSessionLoaderComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private sessionService: SessionPersistenceService
  ) { }

  ngOnInit(): void {
    const shareId = this.route.snapshot.paramMap.get('shareId');
    if (!shareId) {
      this.router.navigate(['/']); // ID non valido, torna alla home
      return;
    }

    this.sessionService.getSharedSession(shareId).subscribe({
      next: (sessionData) => {
        // Step 1: Popola lo stato globale in modalità "sola lettura"
        this.sessionService.populateStateFromLoadedSession(sessionData, true);

        // Step 2: Estrai il projectId
        const projectId = sessionData.sessionData?.metadata?.projectId;

        if (!projectId) {
          console.error('[Loader] Session data is corrupted. Cannot redirect.');
          this.router.navigate(['/']); // Dati corrotti, torna alla home
          return;
        }

        const targetComponent = sessionData.checkpointStage === 'tests' ? 'test' : 'story';
        const destinationUrl = `/projects/${targetComponent}/${projectId}/session/${sessionData.sessionId}`;
        this.router.navigate(['/pages/login'], { queryParams: { returnUrl: destinationUrl } });
      },
      error: (err) => {
        console.error('[Loader] API call failed:', err);
        // Se la chiamata fallisce, reindirizza al login senza un returnUrl
        this.router.navigate(['/pages/login']);
      }
    });
  }
}
